import { getComprasCotizacion, getComprasItemsPaquete } from "../services/comprasService";
import { getExtraCotizacion } from "../services/serviceExtra";
import { getHotelCotizacion } from "../services/serviceHotel";
import { getListadoClientes, getTripIdPaquete, getReporteReferencias, getDetallePaqueteRefencia, getDocuementosCuentaPaquete, getMovimientosCuentaMain, getGrupoViajeUtilidad, postReferenciaTerminos } from "../services/serviceViaje";
import { getVueloCotizacion } from "../services/serviceVuelo";
import { putCancelarPaqueteAgente, putCambiarFechaViajeEditable, putCambiarNumeroMensualidades, getPaqueteHabitacionesReferencia, postPaqueteHabitacionesReferencia, newCheckInPaquete, updateTipoViajePaqueteCliente } from "../services/servicePaquete";
import { putVerificarCuenta, putActulizarDatosContacto } from "../services/serviceUsuarios"
import { getContratacionPlazaReferencia, putContratacionPlaza } from "../services/contratacionService"
import { getNotifiacionesPaquete } from "../services/notificacionesServices";
import { deleteWalletDocument, getWallet, getWalletDocument, postWalletDocument, updateWalletDocument } from "../services/documentosService";
import { getPasajeroAll, updatePasajeroInfo } from "../services/passengerService";
import { putAddItemCustom, putFechaSalidaReferenciaCustom } from "../services/supportServices";
import { getFacturasAceptadasHistoricoAll } from "../services/invoiceService";
import { getDevolucionesHistoricoAll } from "../services/refoundService";
const dataInicial = {
    array: [],
    clientes: [],
    cliente: {},
    verificado: true,
    referencia: "",
    idCotizacion: 0,
    vueloCotizacion: [],
    hotelCotizacion: [],
    extraCotizacion: [],
    comprasCotizacion: [],
    exito: 0,
    objeto: {},
    movimientos: [],
    movimientoPagina: 1,
    movimientosRegistros: 50,
    habitaciones: {},
    plazaContratadas: [],
    plazaDisponibles: [],
    idContratacion: 0,
    comprasItems: [],
    comprasDetalle: {},
    pasajeros: [],
    grupoViajeUtilidad: {},
    notificaciones: [],
    listaDocumentos: [],
    targetPasajero: {},
    nodalPasajero: false,
    facturas: [],
    devoluciones: [],
    extrasContratados: [],
}
const PUT_CLIENTE_WALLET_DOCUMENT = "PUT_CLIENTE_WALLET_DOCUMENT"
const POST_CLIENTE_WALLET_DOCUMENT = "POST_CLIENTE_WALLET_DOCUMENT"
const DELETE_CLIENTE_WALLET = "DELETE_CLIENTE_WALLET"
const GET_CLIENTE_WALLET_DOWLOAD = "GET_CLIENTE_WALLET_DOWLOAD"
const GET_CLIENTE_WALLET_ALL = "GET_CLIENTE_WALLET_ALL"
const GET_CLIENTE_NOTIFICACIONES_PAQUETE = "GET_CLIENTE_NOTIFICACIONES_PAQUETE"
const GET_CLIENTE_GRUPO_VIAJE_UTILIDAD_ACTION = "GET_CLIENTE_GRUPO_VIAJE_UTILIDAD_ACTION"
const GET_LISTADO_CLIENTES = "GET_LISTADO_CLIENTES"
const SELECT_CLIENTE_TARGET = "SELECT_CLIENTE_TARGET"
const GET_MOVIMIENTOS_CUENTA_CLIENTES = "GET_MOVIMIENTOS_CUENTA_CLIENTES"
const GET_CLIENTE_VUELOS_COTIZACION = "GET_CLIENTE_VUELOS_COTIZACION"
const GET_CLIENTE_HOTEL_COTIZACION = "GET_CLIENTE_HOTEL_COTIZACION"
const GET_CLIENTE_EXTRA_COTIZACION = "GET_CLIENTE_EXTRA_COTIZACION"
const GET_CLIENTE_COMPRAS_COTIZACION = "GET_CLIENTE_COMPRAS_COTIZACION"
const GET_CLIENTE_COMRPAS_ITEMS = "GET_CLIENTE_COMRPAS_ITEMS"
const PUT_CLIENTE_BAJA_PAQUETE = "PUT_CLIENTE_BAJA_PAQUETE"
const GET_CLIENTE_REPORTE_ALL = "GET_CLIENTE_REPORTE_ALL"
const GET_CLEINTE_HABITACIONES = "GET_CLEINTE_HABITACIONES"
const POST_CLEINTE_HABITACIONES = "POST_CLEINTE_HABITACIONES"
const PUT_CLEINTE_FECHA_VIAJE = "PUT_CLEINTE_FECHA_VIAJE"
const PUT_CLEINTE_NUMERO_MENSUALIDAES = "PUT_CLEINTE_NUMERO_MENSUALIDAES"
const PUT_CLIENTE_VERIFICADO = "PUT_CLIENTE_VERIFICADO"
const PUT_CLIENTE_DATOS_CONTACTO = "PUT_CLIENTE_DATOS_CONTACTO"
const GET_CLIENTE_PLAZA_CONTRATADA = "GET_CLIENTE_PLAZA_CONTRATADA"
const PUT_CLIENTE_ACTUALIZA_PLAZA = "PUT_CLIENTE_ACTUALIZA_PLAZA"
const GET_CLEINTE_ID_PAQUETE = "GET_CLEINTE_ID_PAQUETE"
const GET_CLEINTE_CHECKIN_CUENTA = "GET_CLEINTE_CHECKIN_CUENTA"
const TARGET_CLIENTE_CHECKIN_PASAJERO = "TARGET_CLIENTE_CHECKIN_PASAJERO"
const PUT_CLIENTE_CHECKIN_PASAJERO = "PUT_CLIENTE_CHECKIN_PASAJERO"
const PUT_CLIENTE_CHECKIN_PASAJERO_ADD = "PUT_CLIENTE_CHECKIN_PASAJERO_ADD"
const PUT_CLIENTE_CHECKIN_VALIDATE = "PUT_CLIENTE_CHECKIN_VALIDATE"
const MODAL_CLIENTE_CHECKIN_PASAJERO = "MODAL_CLIENTE_CHECKIN_PASAJERO"
const POST_CLIENTE_TERMINOS = "POST_CLIENTE_TERMINOS"
const PUT_CLIENTE_CUSTOM_FECHA_SALIDA = "PUT_CLIENTE_CUSTOM_FECHA_SALIDA"
const PUT_CLIENTE_CUSTOM_ADD_ITEM = "PUT_CLIENTE_CUSTOM_ADD_ITEM"
const PUT_CLENTE_INTERNACIONAL_ACTION = "PUT_CLENTE_INTERNACIONAL_ACTION"
const GET_CLIENTE_FACTURAS_ACTION = "GET_CLIENTE_FACTURAS_ACTION"
const GET_CLIENTE_EXTRAS_CONTRATADOS_ACTION = "GET_CLIENTE_EXTRAS_CONTRATADOS_ACTION"
const GET_CLIENTE_DEVOLUCIONES_ACTION = "GET_CLIENTE_DEVOLUCIONES_ACTION"
export default function clientesReducer(state = dataInicial, action) {
    switch (action.type) {
        case GET_CLIENTE_FACTURAS_ACTION:
            return { ...state, facturas: action.payload.facturas }
        case GET_CLIENTE_EXTRAS_CONTRATADOS_ACTION:
            return { ...state, extrasContratados: action.payload.extrasContratados }
        case GET_CLIENTE_DEVOLUCIONES_ACTION:
            return { ...state, devoluciones: action.payload.devoluciones }
        case PUT_CLENTE_INTERNACIONAL_ACTION:
            return { ...state, exito: action.payload.exito, }
        case PUT_CLIENTE_CUSTOM_ADD_ITEM:
            return { ...state, exito: action.payload.exito }
        case POST_CLIENTE_TERMINOS:
            return { ...state, exito: action.payload.exito }
        case PUT_CLIENTE_CUSTOM_FECHA_SALIDA:
            return { ...state, exito: action.payload.exito }
        case POST_CLIENTE_WALLET_DOCUMENT:
            return { ...state, exito: action.payload.exito }
        case PUT_CLIENTE_WALLET_DOCUMENT:
            return { ...state, exito: action.payload.exito }
        case DELETE_CLIENTE_WALLET:
            return { ...state, exito: action.payload.exito }
        case GET_CLIENTE_WALLET_DOWLOAD:
            return { ...state, exito: action.payload.exito }
        case GET_CLIENTE_WALLET_ALL:
            return { ...state, listaDocumentos: action.payload.listaDocumentos }
        case GET_CLIENTE_NOTIFICACIONES_PAQUETE:
            return { ...state, notificaciones: action.payload.notificaciones }
        case GET_CLIENTE_GRUPO_VIAJE_UTILIDAD_ACTION:
            return { ...state, grupoViajeUtilidad: action.payload.grupoViajeUtilidad }
        //*Metodo para el check in del cliente
        case GET_CLEINTE_CHECKIN_CUENTA:
            return { ...state, pasajeros: action.payload.pasajeros }
        case TARGET_CLIENTE_CHECKIN_PASAJERO:
            return { ...state, targetPasajero: action.payload.targetPasajero }
        case MODAL_CLIENTE_CHECKIN_PASAJERO:
            return { ...state, modalPasajero: action.payload.modalPasajero }
        case PUT_CLIENTE_CHECKIN_PASAJERO_ADD:
            return { ...state, exito: action.payload.exito }
        case PUT_CLIENTE_CHECKIN_PASAJERO:
            return { ...state, exito: action.payload.exito }
        case PUT_CLIENTE_CHECKIN_VALIDATE:
            return { ...state, exito: action.payload.exito }
        //**Metodo para el check in del cliente
        case PUT_CLEINTE_NUMERO_MENSUALIDAES:
            return { ...state, exito: action.payload.exito }
        case GET_CLIENTE_COMRPAS_ITEMS:
            return { ...state, comprasItems: action.payload.comprasItems, comprasDetalle: action.payload.comprasDetalle }
        case PUT_CLIENTE_ACTUALIZA_PLAZA:
            return { ...state, exito: action.payload.payload }
        case GET_CLIENTE_PLAZA_CONTRATADA:
            return { ...state, plazaContratadas: action.payload.plazaContratadas, plazaDisponibles: action.payload.plazaDisponibles, idContratacion: action.payload.idContratacion }
        case POST_CLEINTE_HABITACIONES:
            return { ...state, exito: action.payload.exito }
        case GET_CLEINTE_HABITACIONES:
            return { ...state, habitaciones: action.payload.habitaciones }
        case PUT_CLIENTE_DATOS_CONTACTO:
            return { ...state, exito: action.payload.exito }
        case PUT_CLIENTE_VERIFICADO:
            return { ...state, exito: action.payload.exito }
        case PUT_CLEINTE_FECHA_VIAJE:
            return { ...state, exito: action.payload.exito }
        case GET_CLIENTE_REPORTE_ALL:
            return { ...state, exito: action.payload.exito }
        case PUT_CLIENTE_BAJA_PAQUETE:
            return { ...state, exito: action.payload.exito }
        case GET_CLIENTE_COMPRAS_COTIZACION:
            return { ...state, comprasCotizacion: action.payload.comprasCotizacion }
        case GET_CLIENTE_EXTRA_COTIZACION:
            return { ...state, extraCotizacion: action.payload.extraCotizacion }
        case GET_CLIENTE_HOTEL_COTIZACION:
            return { ...state, hotelCotizacion: action.payload.hotelCotizacion }
        case GET_CLIENTE_VUELOS_COTIZACION:
            return { ...state, vueloCotizacion: action.payload.vueloCotizacion }
        case GET_MOVIMIENTOS_CUENTA_CLIENTES:
            return { ...state, movimientos: action.payload.movimientos }
        case GET_CLEINTE_ID_PAQUETE:
            return { ...state, cliente: action.payload.cliente, referencia: action.payload.referencia, idCotizacion: action.payload.idCotizacion, verificado: action.payload.verificado }
        case SELECT_CLIENTE_TARGET:
            return { ...state, cliente: action.payload.cliente, referencia: action.payload.referencia, idCotizacion: action.payload.idCotizacion, verificado: action.payload.verificado }
        case GET_LISTADO_CLIENTES:
            return { ...state, clientes: action.payload.clientes };
        default:
            return state;
    }
}
export const cambiarTipoViajeClienteAction = ({ idPaquete, EsInternacional }) => async (dispatch) => {
    return await updateTipoViajePaqueteCliente({ IdPaquete: idPaquete, EsInternacional }).then(Response => {
        dispatch({
            type: PUT_CLENTE_INTERNACIONAL_ACTION,
            payload: {
                exito: 1
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
export const nuevoWalletDocumentoAction = ({ idPaquete, Imagen, Nombre }) => async (dispatch) => {
    return await postWalletDocument({ idPaquete, Imagen, Nombre }).then(Response => {
        dispatch({
            type: POST_CLIENTE_WALLET_DOCUMENT,
            payload: {
                exito: 1
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
export const actualizarWalletDocumentoAction = ({ idDocumento, Nombre, Imagen }) => async (dispatch) => {
    return await updateWalletDocument({ idCatDocumentoPaquete: idDocumento, Nombre, Imagen }).then(Response => {
        dispatch({
            type: PUT_CLIENTE_WALLET_DOCUMENT,
            payload: {
                exito: 1
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
export const eliminarWalletDocuemntoAction = ({ idDocumento }) => async (dispatch) => {
    return await deleteWalletDocument({ idCatDocumentoPaquete: idDocumento }).then(Response => {
        dispatch({
            type: DELETE_CLIENTE_WALLET,
            payload: {
                exito: 1
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
export const obtenrWalletDocumentoAction = ({ idDocumento }) => async (dispatch) => {
    return await getWalletDocument({ idCatDocumentoPaquete: idDocumento }).then(Response => {
        dispatch({
            type: GET_CLIENTE_WALLET_DOWLOAD,
            payload: {
                exito: 1
            }
        })
        return Response
    }).then(Error => {
        return Error
    })
}
export const obtenrWalletPaqueteAction = ({ idPaquete }) => async (dispatch) => {
    return await getWallet({ idPaquete }).then(Response => {
        dispatch({
            type: GET_CLIENTE_WALLET_ALL,
            payload: {
                listaDocumentos: Response,
            },
        })
    }).catch(Error => {
    })
}
export const obtenerGrupoViajeUtilidad = ({ ClaveViaje }) => async (dispatch) => {
    return await getGrupoViajeUtilidad({ ClaveViaje }).then(Response => {
        dispatch({
            type: GET_CLIENTE_GRUPO_VIAJE_UTILIDAD_ACTION,
            payload: {
                grupoViajeUtilidad: Response,
            },
        })
    }).catch(Error => {
    })
}
/**
 * Todo: Inicio Acciones compras cliente
 */
export const obtenerClienteItemsPaquete = () => (dispatch, useState) => {
    const { cliente, referencia } = useState().cliente
    Promise.all([getComprasItemsPaquete({ IdPaquete: cliente?.paquete?.Id_Paquete }), getDetallePaqueteRefencia({ idPaquete: cliente?.paquete?.Id_Paquete, referencia })]).then((values) => {
        dispatch({
            type: GET_CLIENTE_COMRPAS_ITEMS,
            payload: {
                comprasItems: values[0],
                comprasDetalle: values[1]
            },
        })
    });
}
export const obtenerClienteItemsPaqueteAction = ({ IdPaquete, referencia }) => (dispatch, useState) => {
    Promise.all([getComprasItemsPaquete({ IdPaquete: IdPaquete }), getDetallePaqueteRefencia({ idPaquete: IdPaquete, referencia })]).then((values) => {
        dispatch({
            type: GET_CLIENTE_COMRPAS_ITEMS,
            payload: {
                comprasItems: values[0],
                comprasDetalle: values[1]
            },
        })
    });
}
/**
 * Todo: Fin Acciones compras cliente
 */
export const onbtenerClientePaquete = () => async (dispatch, getState) => {
    const { cliente, referencia } = getState().cliente
    return await getTripIdPaquete({ IdPaquete: cliente?.paquete?.Id_Paquete }).then(Response => {
        dispatch({
            type: GET_CLEINTE_ID_PAQUETE,
            payload: {
                cliente: Response,
                referencia: referencia,
                idCotizacion: (cliente?.idCotizacion > 0) ? cliente?.idCotizacion : 0,
                verificado: Response?.Movimiento?.Cuenta?.Verificado
            },
        })
    }).catch(Error => {
    })
}
export const selectClienteTarget = ({ cliente, referencia }) => async (dispatch) => {
    return await getTripIdPaquete({ IdPaquete: cliente?.paquete?.Id_Paquete }).then(Response => {
        dispatch({
            type: SELECT_CLIENTE_TARGET,
            payload: {
                cliente: Response,
                referencia: referencia,
                idCotizacion: (cliente?.idCotizacion > 0) ? cliente?.idCotizacion : 0,
                verificado: Response?.Movimiento?.Cuenta?.Verificado
            },
        })
    }).catch(Error => {
        dispatch({
            type: SELECT_CLIENTE_TARGET,
            payload: {
                cliente: {},
                referencia: referencia,
                idCotizacion: (cliente?.idCotizacion > 0) ? cliente?.idCotizacion : 0,
                verificado: true
            },
        })
    })
}
//TODO: METODOS HABITACIONES
export const actulizaContracionPlazaAction = ({ IdContratacion, suplementosEnviados }) => async (dispatch) => {
    return await putContratacionPlaza({ IdContratacion, suplementosEnviados }).then(Response => {
        dispatch({
            type: PUT_CLIENTE_ACTUALIZA_PLAZA,
            payload: {
                exito: 1,
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })

}
export const obtenerHabitacionesContratadas = ({ Referencia }) => async (dispatch) => {
    return await getContratacionPlazaReferencia({ Referencia }).then(Response => {
        dispatch({
            type: GET_CLIENTE_PLAZA_CONTRATADA,
            payload: {
                plazaContratadas: Response?.plazaContratados,
                plazaDisponibles: Response?.plazaDisponibles,
                idContratacion: Response?.contratacion?.IdContratacion
            },
        });
    }).catch(Error => {
        return []
    })

}
export const obtenerPaqueteHabitaciones = ({ Referencia }) => async (dispatch) => {
    return await getPaqueteHabitacionesReferencia({ Referencia }).then(Response => {
        dispatch({
            type: GET_CLEINTE_HABITACIONES,
            payload: {
                habitaciones: Response,
            },
        });
    }).catch(Error => {
        return {}
    })

}
export const cargarPaqueteHabitaciones = ({ Referencia, Triple, Doble, Sencilla, Menor, Compartida, Cuadruple }) => async (dispatch) => {
    return await postPaqueteHabitacionesReferencia({ Referencia, Triple, Doble, Sencilla, Menor, Compartida, Cuadruple }).then(Response => {
        dispatch({
            type: POST_CLEINTE_HABITACIONES,
            payload: {
                habitaciones: Response,
            },
        });
    }).catch(Error => {
        return {}
    })

}
export const obtenerListadoClientes = () => async (dispatch) => {
    return await getListadoClientes().then(Response => {
        dispatch({
            type: GET_LISTADO_CLIENTES,
            payload: {
                clientes: Response,
            },
        });
    }).catch(Error => {
        return []
    })

}
export const obtenerVueloCotizacion = ({ idCotizacion }) => async (dispatch, getState) => {
    return await getVueloCotizacion({ IdCotizacion: idCotizacion }).then(Response => {
        dispatch({
            type: GET_CLIENTE_VUELOS_COTIZACION,
            payload: {
                vueloCotizacion: Response,
            },
        });
    }).catch(Error => {
        return []
    })
}
export const obtenerHotelCotizacion = ({ idCotizacion }) => async (dispatch, getState) => {
    return await getHotelCotizacion({ IdCotizacion: idCotizacion }).then(Response => {
        dispatch({
            type: GET_CLIENTE_HOTEL_COTIZACION,
            payload: {
                hotelCotizacion: Response,
            },
        });
    }).catch(Error => {
        return []
    })
}
export const obtenerExtraCotizacion = ({ idCotizacion }) => async (dispatch, getState) => {
    return await getExtraCotizacion({ IdCotizacion: idCotizacion }).then(Response => {
        dispatch({
            type: GET_CLIENTE_EXTRA_COTIZACION,
            payload: {
                extraCotizacion: Response,
            },
        });
    }).catch(Error => {
        return []
    })
}
export const obtenerComprasCotizacion = ({ idCotizacion }) => async (dispatch) => {
    return await getComprasCotizacion({ IdCotizacion: idCotizacion }).then(Response => {
        dispatch({
            type: GET_CLIENTE_COMPRAS_COTIZACION,
            payload: {
                comprasCotizacion: Response
            }
        })
    }).catch(Error => {
        return []
    })
}
//TODO: Verificacion de cuentas
export const verificarCuentaAction = ({ IdCuenta }) => async (dispatch) => {
    return await putVerificarCuenta({ IdCuenta, Verificado: 1 }).then(Response => {
        dispatch({
            type: PUT_CLIENTE_VERIFICADO,
            payload: {
                exito: 1,
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })
}
export const anularVerificarCuentaAction = ({ IdCuenta }) => async (dispatch) => {
    return await putVerificarCuenta({ IdCuenta, Verificado: 0 }).then(Response => {
        dispatch({
            type: PUT_CLIENTE_VERIFICADO,
            payload: {
                exito: 1,
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })
}
export const actulizarDatosContactoAction = ({ Referencia, nombre, apellidoP, apellidoM, telefono, correo }) => async (dispatch) => {
    return await putActulizarDatosContacto({ Referencia, nombre, apellidoP, apellidoM, telefono, correo }).then(Response => {
        dispatch({
            type: PUT_CLIENTE_DATOS_CONTACTO,
            payload: {
                exito: 1,
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })
}
/**
 * TODO: Metodos movimientos
 */
export const obtenerMovimientoCuentaCliente = ({ referencia }) => async (dispatch, getState) => {
    const { movimientoPagina, movimientosRegistros } = getState().cliente
    return await getMovimientosCuentaMain({ Referencia: referencia, Pagina: movimientoPagina, Registros: movimientosRegistros }).then(Response => {
        dispatch({
            type: GET_MOVIMIENTOS_CUENTA_CLIENTES,
            payload: {
                movimientos: Response,
            },
        });
    }).catch(Error => {
        return []
    })
}
/**
 * TODO: Metodos cambios de paquete
 */
export const cambiarEstatusPaquete = ({ IdPaquete, IdEstatusProceso }) => async (dispatch) => {
    return await putCancelarPaqueteAgente({ IdPaquete, IdEstatusProceso }).then(Response => {
        dispatch({
            type: PUT_CLIENTE_BAJA_PAQUETE,
            payload: {
                exito: 1,
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })
}
export const cambiarFechaViajeAction = ({ IdPaquete, IdBloqueSalida, IdObjeto }) => async (dispatch) => {
    return await putCambiarFechaViajeEditable({ IdPaquete, IdBloqueSalida, IdObjeto }).then(Response => {
        dispatch({
            type: PUT_CLEINTE_FECHA_VIAJE,
            payload: {
                exito: 1,
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })
}
export const cambiarMensualidadesAction = ({ IdPaquete, NumeroPagos }) => async (dispatch) => {
    return await putCambiarNumeroMensualidades({ IdPaquete, NumeroPagos }).then(Response => {
        dispatch({
            type: PUT_CLEINTE_NUMERO_MENSUALIDAES,
            payload: {
                exito: 1,
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })
}
/**
 * TODO: Metodos reportes
 */
export const obtneerReporteReferenciasAllAction = () => async (dispatch) => {
    return await getReporteReferencias().then(Response => {
        dispatch({
            type: GET_CLIENTE_REPORTE_ALL,
            payload: {
                exito: 1,
            },
        });
        return Response
    }).catch(Error => {
        return []
    })
}
//*Metodos para el check in del cliente 
export const obtenerPasajerosDocumentos = ({ idPaquete }) => async (dispatch) => {
    return await getPasajeroAll({ IdPaquete: idPaquete }).then(Response => {
        dispatch({
            type: GET_CLEINTE_CHECKIN_CUENTA,
            payload: {
                pasajeros: Response
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
export const targetPasajeroCheckin = ({ pasajero }) => async (dispatch) => {
    dispatch({
        type: TARGET_CLIENTE_CHECKIN_PASAJERO,
        payload: {
            targetPasajero: pasajero
        }
    })
}
export const modalPasajeroCheckin = ({ open = false }) => async (dispatch) => {
    dispatch({
        type: MODAL_CLIENTE_CHECKIN_PASAJERO,
        payload: {
            modalPasajero: open
        }
    })
}
export const updatePasajeroCheckin = ({ FechaNacimiento, IdPasajero, IdPaquete, idCuenta, ApellidoMaterno, ApellidoPaterno, FechaVencimiento, IdCatTipoPasajero, Internacional, Nacionalidad, Nombre, NumeroPasaporte }) => async (dispatch) => {
    return await updatePasajeroInfo({ FechaNacimiento, IdPasajero, IdPaquete, idCuenta, ApellidoMaterno, ApellidoPaterno, FechaVencimiento, IdCatTipoPasajero, Internacional, Nacionalidad, Nombre, NumeroPasaporte }).then(Response => {
        dispatch({
            type: PUT_CLIENTE_CHECKIN_PASAJERO,
            payload: {
                exito: 1
            },
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
export const newPasajeroCheckin = ({ FechaNacimiento, IdPaquete, idCuenta, ApellidoMaterno, ApellidoPaterno, FechaVencimiento, IdCatTipoPasajero, Internacional, Nacionalidad, Nombre, NumeroPasaporte }) => async (dispatch) => {
    return await updatePasajeroInfo({ FechaNacimiento, IdPasajero: 0, IdPaquete, idCuenta, ApellidoMaterno, ApellidoPaterno, FechaVencimiento, IdCatTipoPasajero, Internacional, Nacionalidad, Nombre, NumeroPasaporte }).then(Response => {
        dispatch({
            type: PUT_CLIENTE_CHECKIN_PASAJERO_ADD,
            payload: {
                exito: 1
            },
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
export const updatePasajeroCheckinValidate = ({ IdPaquete }) => async (dispatch) => {
    return await newCheckInPaquete({ idPaquete: IdPaquete }).then(Response => {
        dispatch({
            type: PUT_CLIENTE_CHECKIN_VALIDATE,
            payload: {
                exito: 1
            },
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
//**Metodos para el check in del cliente 
export const obtenerNotificacionesPaquete = ({ idPaquete }) => async (dispatch) => {
    return await getNotifiacionesPaquete({ idPaquete }).then(Response => {
        dispatch({
            type: GET_CLIENTE_NOTIFICACIONES_PAQUETE,
            payload: {
                notificaciones: Response,
            },
        });
    }).catch(Error => {
        return []
    })
}
//** Metodo para suport */
export const AceptarTerminosCondiciones = ({ referencia }) => async (dispatch) => {
    return await postReferenciaTerminos({ Referencia: referencia }).then(Response => {
        dispatch({
            type: POST_CLIENTE_TERMINOS,
            payload: {
                exito: 1,
            },
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
export const CambiarFechaCustomAction = ({ referencia, fechaSalida, montoUnitario }) => async (dispatch) => {
    return await putFechaSalidaReferenciaCustom({ Referencia: referencia, FechaSalida: fechaSalida, MontoUnitario: montoUnitario }).then(Response => {
        dispatch({
            type: PUT_CLIENTE_CUSTOM_FECHA_SALIDA,
            payload: {
                exito: 1,
            },
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
export const AddItemCustomAction = ({ referencia, descripcion, montoUnitario, nombre }) => async (dispatch) => {
    return await putAddItemCustom({ Referencia: referencia, Descripcion: descripcion, MontoUnitario: montoUnitario, Nombre: nombre }).then(Response => {
        dispatch({
            type: PUT_CLIENTE_CUSTOM_ADD_ITEM,
            payload: {
                exito: 1,
            },
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
//** Metodos para consulta de facturas */
export const obtenerPeticionesFacturasReferenciaAction = ({ referencia }) => async (dispatch) => {
    return await getFacturasAceptadasHistoricoAll({ IdCatEstatusDevolucion: 0, Pagina: 1, Referencia: referencia, Registros: 100 }).then(Response => {
        dispatch({
            type: GET_CLIENTE_FACTURAS_ACTION,
            payload: {
                facturas: Response?.Facturas ?? [],
            },
        });
    }).catch(Error => {
        return []
    })
}
// //** Metodos para consulta de extras */
export const obtenerPeticionesEctrasReferenciaAction = ({referencia}) => async (dispatch) => {
    // return await getNotifiacionesPaquete({ idPaquete }).then(Response => {
    //     dispatch({
    //         type: GET_CLIENTE_EXTRAS_CONTRATADOS_ACTION,
    //         payload: {
    //             extrasContratados: Response,
    //         },
    //     });
    // }).catch(Error => {
    //     return []
    // })
}
// //** Metodos para consulta de devoluciones */
export const obtenerPeticionesDevolucionesReferenciaAction = ({ referencia }) => async (dispatch) => {
    return await getDevolucionesHistoricoAll({ IdCatEstatusDevolucion: 0, Pagina: 1, Referencia: referencia, Registros: 100 }).then(Response => {
        dispatch({
            type: GET_CLIENTE_DEVOLUCIONES_ACTION,
            payload: {
                devoluciones: Response?.Devoluciones ?? [],
            },
        });
    }).catch(Error => {
        return []
    })
}